import external from '../../externalModules';

if (typeof Object.assign != 'function') {
  Object.assign = function(target) {
    'use strict';
    if (target == null) {
      throw new TypeError('Cannot convert undefined or null to object');
    }

    target = Object(target);
    for (var index = 1; index < arguments.length; index++) {
      var source = arguments[index];
      if (source != null) {
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
    }
    return target;
  };
}

const configuration = {
  iconSize: 16,
  viewBox: {
    x: 16,
    y: 16,
  },
  mousePoint: {
    x: 8,
    y: 8,
  },
  mousePointerGroupString: `
    <path stroke="ACTIVE_COLOR" d="M8 16L8 0"></path>
    <path stroke="ACTIVE_COLOR" d="M16 8L0 8"></path>
  `,
};

const setters = {
  defaultOptions: newOptions => {
    Object.assign(configuration, newOptions);
  },
};

const getters = {
  defaultOptions: () => configuration,
};

export default {
  configuration,
  getters,
  setters,
};
